import crud from './helpers/crud';

const getCategoriesByPage = (page = 1, pageSize = 10) => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_CATEGORIES',
      fail: 'FAILED_GET_CATEGORIES',
      end: 'FINISH_GET_CATEGORIES',
    },
    method: 'GET',
    url: `/api/v1/document_categories?page=${page}&page_size=${pageSize}`,
  })
);

const getCategoriesByQuery = (query) => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_CATEGORIES',
      fail: 'FAILED_GET_CATEGORIES',
      end: 'FINISH_GET_CATEGORIES',
    },
    method: 'GET',
    url: `/api/v1/document_categories${query}`,
  })
);

const createNewCategory = (categoryObject) => (
  crud({
    dispatch: {
      begin: 'BEGIN_CREATE_CATEGORY',
      fail: 'FAILED_CREATE_CATEGORY',
      end: 'FINISH_CREATE_CATEGORY',
    },
    method: 'POST',
    data: { category: categoryObject },
    url: '/api/v1/document_categories',
  })
);

const deleteCategory = (id) => (
  crud({
    dispatch: {
      begin: 'BEGIN_DELETE_CATEGORY',
      fail: 'FAILED_DELETE_CATEGORY',
      end: 'FINISH_DELETE_CATEGORY',
    },
    method: 'DELETE',
    url: `/api/v1/document_categories/${id}`,
  })
);

const updateCategory = (id, categoryObject) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_CATEGORY',
      fail: 'FAILED_UPDATE_CATEGORY',
      end: 'FINISH_UPDATE_CATEGORY',
    },
    method: 'PUT',
    url: `/api/v1/document_categories/${id}`,
    data: { category: categoryObject },
  })
);

const getCategoryCatalog = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_CATEGORY_CATALOG',
      fail: 'FAILED_GET_CATEGORY_CATALOG',
      end: 'FINISH_GET_CATEGORY_CATALOG',
    },
    method: 'GET',
    url: '/api/v1/document_categories/catalog',
  })
);

const enableSupportedCategory = (supportedId) => (
  crud({
    dispatch: {
      begin: 'BEGIN_ENABLE_SUPPORTED_CATEGORY',
      fail: 'FAILED_ENABLE_SUPPORTED_CATEGORY',
      end: 'FINISH_ENABLE_SUPPORTED_CATEGORY',
    },
    method: 'POST',
    url: `/api/v1/document_categories/catalog/${supportedId}/enable`,
  })
);

const disableSupportedCategory = (supportedId) => (
  crud({
    dispatch: {
      begin: 'BEGIN_DISABLE_SUPPORTED_CATEGORY',
      fail: 'FAILED_DISABLE_SUPPORTED_CATEGORY',
      end: 'FINISH_DISABLE_SUPPORTED_CATEGORY',
    },
    method: 'POST',
    url: `/api/v1/document_categories/catalog/${supportedId}/disable`,
  })
);

const addClassificationHint = (documentCategoryId, hint) => (
  crud({
    dispatch: {
      begin: 'BEGIN_ADD_CATEGORY_HINT',
      fail: 'FAILED_ADD_CATEGORY_HINT',
      end: 'FINISH_ADD_CATEGORY_HINT',
    },
    method: 'POST',
    url: `/api/v1/document_categories/${documentCategoryId}/hints`,
    data: { hint },
  })
);

const removeClassificationHint = (documentCategoryId, index) => (
  crud({
    dispatch: {
      begin: 'BEGIN_REMOVE_CATEGORY_HINT',
      fail: 'FAILED_REMOVE_CATEGORY_HINT',
      end: 'FINISH_REMOVE_CATEGORY_HINT',
    },
    method: 'DELETE',
    url: `/api/v1/document_categories/${documentCategoryId}/hints/${index}`,
  })
);

// Saves the two-part custom titling for a category: an example title and a
// description of what each part means. Sending both blank clears it.
const setTitleInstruction = (documentCategoryId, { titleExample, titleInstruction }) => (
  crud({
    dispatch: {
      begin: 'BEGIN_SET_CATEGORY_TITLE_INSTRUCTION',
      fail: 'FAILED_SET_CATEGORY_TITLE_INSTRUCTION',
      end: 'FINISH_SET_CATEGORY_TITLE_INSTRUCTION',
    },
    method: 'PUT',
    url: `/api/v1/document_categories/${documentCategoryId}/title_instruction`,
    data: { title_example: titleExample, title_instruction: titleInstruction },
  })
);

// Replaces the full list of title options (per-category document titles) for a
// category. When set, the AI picks the document title from this list and manual
// uploads suggest these titles; an empty array clears it (plain free text).
const setTitleOptions = (documentCategoryId, titleOptions) => (
  crud({
    dispatch: {
      begin: 'BEGIN_SET_CATEGORY_TITLE_OPTIONS',
      fail: 'FAILED_SET_CATEGORY_TITLE_OPTIONS',
      end: 'FINISH_SET_CATEGORY_TITLE_OPTIONS',
    },
    method: 'PUT',
    url: `/api/v1/document_categories/${documentCategoryId}/title_options`,
    data: { title_options: titleOptions },
  })
);

// Per-fax-line auto-upload configuration: which fax lines upload each document
// category automatically. Distinct from the org-level allow-list on the EMR
// integration credential (getEmrAutoUploadCategorySettings in actions/userProfile).
const getAutoUploadCategories = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_AUTO_UPLOAD_CATEGORIES',
      fail: 'FAILED_GET_AUTO_UPLOAD_CATEGORIES',
      end: 'FINISH_GET_AUTO_UPLOAD_CATEGORIES',
    },
    method: 'GET',
    url: '/api/v1/auto_upload_categories',
  })
);

// Replaces the whole set of fax lines for one category, so a single save both
// adds and removes. An empty array turns auto-upload off for the category.
const updateAutoUploadCategoryLines = (documentCategoryId, faxNumberIds) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_AUTO_UPLOAD_CATEGORY',
      fail: 'FAILED_UPDATE_AUTO_UPLOAD_CATEGORY',
      end: 'FINISH_UPDATE_AUTO_UPLOAD_CATEGORY',
    },
    method: 'PUT',
    url: `/api/v1/auto_upload_categories/${documentCategoryId}`,
    data: { auto_upload_category: { fax_number_ids: faxNumberIds } },
  })
);

const setCategorySftpOnly = (documentCategoryId, enabled) => (
  crud({
    dispatch: {
      begin: 'BEGIN_SET_CATEGORY_SFTP_ONLY',
      fail: 'FAILED_SET_CATEGORY_SFTP_ONLY',
      end: 'FINISH_SET_CATEGORY_SFTP_ONLY',
    },
    method: 'PUT',
    url: `/api/v1/document_categories/${documentCategoryId}/sftp_only`,
    data: { enabled },
  })
);

export {
  setCategorySftpOnly,
  getCategoriesByPage,
  createNewCategory,
  deleteCategory,
  updateCategory,
  getCategoriesByQuery,
  getCategoryCatalog,
  enableSupportedCategory,
  disableSupportedCategory,
  addClassificationHint,
  removeClassificationHint,
  setTitleInstruction,
  setTitleOptions,
  getAutoUploadCategories,
  updateAutoUploadCategoryLines,
};
